import React, { useState } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import hero251 from "../../assets/images/Hero251.png";
import { shouldUseReducedMedia } from "../../utils/browser";

const LOTTIE_SRC =
  "https://lottie.host/37a7b2d3-090c-4dc6-b593-ef0a0c95f6e1/v7mcd4En7C.lottie";

const HeroLottie = ({ className = "" }) => {
  const [useFallback, setUseFallback] = useState(shouldUseReducedMedia);

  if (useFallback) {
    return (
      <img
        src={hero251}
        alt=""
        className={`hero-lottie-fallback ${className}`.trim()}
        loading="eager"
        decoding="async"
      />
    );
  }

  return (
    <DotLottieReact
      src={LOTTIE_SRC}
      loop
      autoplay
      speed={1.0}
      className={className}
      onError={() => setUseFallback(true)}
    />
  );
};

export default HeroLottie;
